import getCargoSender from '~/api/senders/cargo-sender';

export default class PricingMethods {
  constructor () {
    this.sender = getCargoSender();
    this.route = 'expeditor/pricing';
  }

  getRequirements (req) {
    return this.sender.post('/handler/requirements', req.buildRequirements());
  }

  getPricing (req) {
    return this.sender.get(this.route, req.buildPricing());
  }

  getNewPricing (req) {
    return this.sender.get(`expeditor/v1.1/pricing`, req.buildPricing(), {
      id: 'pricing',
      cancellable: true,
    });
  }

  getByRaidIds (req) {
    return this.sender.get(`${this.route}-by-raids`, req.buildPricingByRaids());
  }

  /* getByRaidIds (req) {
    return this.sender.get(`expeditor/v1.1/pricing`, req.buildPricingByRaids()).then(res => {
      const variant = res.data.result.find(item => {
        return item.segments.every(segment => {
          return req.raids.includes(String(segment.raidId));
        });
      });
      variant.dictionary = res.data.dictionary;
      return Promise.resolve({ data: variant });
    });
  } */

  abort () {
    this.sender.abort();
  }
}
